// extracted by mini-css-extract-plugin
module.exports = {"modal":"FeebackModal_modal__6bNkc","icon":"FeebackModal_icon__AotYG","content":"FeebackModal_content__h2OPt","secondaryText":"FeebackModal_secondaryText__dNuQv"};